import { FC } from 'react';

import { BreadcrumbList, WithContext } from 'schema-dts';

export interface Breadcrumb {
  name: string;
  url: string;
}

// `url` must be absolute: Search Console rejects relative paths in `itemListElement.item`.
export const BreadcrumbSchema: FC<{ breadcrumbs: Breadcrumb[] }> = ({ breadcrumbs }) => {
  const schema: WithContext<BreadcrumbList> = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',

    itemListElement: breadcrumbs.map((crumb, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.name,
        item: crumb.url,
      };
    }),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema, null, 2),
      }}
    ></script>
  );
};
